import { render, staticRenderFns } from "./actividades-medicina.vue?vue&type=template&id=369953d2&"
import script from "./actividades-medicina.vue?vue&type=script&lang=js&"
export * from "./actividades-medicina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports